export const getThemeColor = (business) => {
    if (business && business.info) {
        return business.info.theme_color
            ? business.info.theme_color
            : '#FFFFFF';
    }
    return '#FFFFFF';
};

export default getThemeColor;
